/**
 * @file usePickListPrint.ts
 * @description Печать листа комплектации (phase19.14, W13).
 *
 * Общий кусок для очереди и карточки задания: скачать PDF, показать «идёт
 * печать» и человеческую ошибку. Вынесен, чтобы обе страницы не держали одну и
 * ту же обвязку `try/catch/saveBlob`.
 */

import { useCallback, useState } from "react";

import { useNotify } from "../../ui/NotifyProvider";
import { pickingApi } from "../../../lib/api-picking";
import { saveBlob } from "../../../lib/download";
import { wmsErrorText } from "../../../lib/wms-error-text";

interface UsePickListPrintResult {
  /** id задания, которое печатается сейчас; null — печати нет. */
  printingId: string | null;
  print: (task: { id: string; number: string }) => Promise<void>;
}

export function usePickListPrint(): UsePickListPrintResult {
  const notify = useNotify();
  const [printingId, setPrintingId] = useState<string | null>(null);

  const print = useCallback(
    async (task: { id: string; number: string }) => {
      setPrintingId(task.id);
      try {
        const file = await pickingApi.printPickList(task.id, task.number);
        saveBlob(file.blob, file.filename);
      } catch (err) {
        notify.error(wmsErrorText(err, "Не удалось получить лист комплектации"));
      } finally {
        setPrintingId(null);
      }
    },
    [notify],
  );

  return { printingId, print };
}
